import ImpureChessPrivacyPolicy from '../components/Docs/ImpureChessPrivacyPolicy.js';
import Page from '../components/Page/Page.js';

function ImpureChessPrivacyPolicyPage()
{
    return(
        <Page mainSection={<ImpureChessPrivacyPolicy />} />
    );
}

export default ImpureChessPrivacyPolicyPage;